import styled from 'styled-components'

export const IconShell = styled.div`
  align-items: center;
  background: ${({ theme }) => theme.palette.colors.badgeMuted};
  border-radius: 999px;
  color: ${({ theme }) => theme.palette.blue.main};
  display: flex;
  height: 54px;
  justify-content: center;
  margin-bottom: 16px;
  width: 54px;
`

export const Title = styled.h2`
  color: ${({ theme }) => theme.palette.colors.text};
  font-size: 24px;
  margin: 0;
`

export const Message = styled.p`
  color: ${({ theme }) => theme.palette.colors.muted};
  font-size: 16px;
  line-height: 1.5;
  margin: 10px 0 0;
`

export const Actions = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: 24px;
`
